import Dialog from './Dialog.vue';
import { DialogAutoMounterManager } from './DialogAutoMounterManager';

export { DialogAutoMounterManager };

export default Dialog;
